import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { RetailerNetworkLocationFragment } from '@occc/graphql';

import { RetailerNetworkUserDetailsLocationsTableRow } from './retailer-network-user-details-locations-table-row.component';

import { useGetRetailerNetworkLocations } from '../../../../data-access/queries';

type RetailerNetworkUserDetailsLocationsTableProps = {
  locationsData: ReturnType<typeof useGetRetailerNetworkLocations>;
  handleOpenLocationDetailsPage: (locationUuid: string) => void;
  handleRemoveUserFromLocation: (locationUuid: string) => void;
  isCurrentUserPermittedToDisassociate: boolean;
};

export const RetailerNetworkUserDetailsLocationsTable = ({
  locationsData,
  handleOpenLocationDetailsPage,
  handleRemoveUserFromLocation,
  isCurrentUserPermittedToDisassociate,
}: RetailerNetworkUserDetailsLocationsTableProps) => {
  const { loading: locationsLoading, error, data, paginationProps } = locationsData;

  const renderData = (items: RetailerNetworkLocationFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name (DBA)</TableCell>
            <TableCell>Site Address</TableCell>
            <TableCell>Site Phone Number</TableCell>
            <TableCell align='right'>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <RetailerNetworkUserDetailsLocationsTableRow
              location={item.location}
              isLocationInheritedFromGroup={!!item.userAssociationInheritedFromLocationGroup}
              key={item.location.uuid}
              handleOpenLocationDetailsPage={handleOpenLocationDetailsPage}
              handleRemoveUserFromLocation={handleRemoveUserFromLocation}
              isCurrentUserPermittedToDisassociate={isCurrentUserPermittedToDisassociate}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationFragment>
      error={error}
      loading={locationsLoading}
      items={data}
      renderData={renderData}
    />
  );
};
